import { useContextSelectors } from "@-/com.npmjs.use-context-selectors";
import { ActorDatabaseContext } from "@-/dev.improve.haniverse.contexts.database.actor";
import { ContentDatabaseContext } from "@-/dev.improve.haniverse.contexts.database.content";
import { getTaiwanUsageMap } from "@-/dev.improve.haniverse.data.taiwan-usage-map";
import { useMutation } from "@-/com.npmjs.tanstack__react-query";
import { createUserCard } from "@-/dev.improve.haniverse.lib.cards.user-card.create";
import { useActorUser } from "@-/dev.improve.haniverse.lib.user";
import type { GraphemeLessonPart } from "@-/dev.improve.haniverse.lib.level";

type CreateUserCardGrapheme = { front: string };

export function useCreateUserCard() {
  const [actorDb] = useContextSelectors(ActorDatabaseContext, (c) => c.db);
  const [contentDb] = useContextSelectors(ContentDatabaseContext, (c) => c.db);
  const { hanziScript } = useActorUser();
  return useMutation({
    mutationFn: async ({
      graphemeCard,
      part,
      startedStudyingAt,
    }: {
      graphemeCard: CreateUserCardGrapheme;
      part?: Exclude<GraphemeLessonPart, "pronunciation">;
      startedStudyingAt?: string;
    }) => {
      // The TW usage map and component-prevalence closures `createUserCard` needs are precomputed
      // at static-DB build time and read synchronously. Pulling the map here (rather than inside
      // `createUserCard`) keeps the pure function free of the bundled asset import and makes the
      // same code path callable from the server-side test seed route (which passes its own map).
      const twUsageMap = getTaiwanUsageMap();

      return createUserCard({
        actorDb,
        contentDb,
        graphemeCard,
        hanziScript,
        part,
        startedStudyingAt,
        twUsageMap,
      });
    },
    mutationKey: ["createUserCard"],
  });
}
